import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  fetchEventList,
  fetchRiderList
} from '../actions/library'

import { setModal } from '../actions/modal'

import Loading from '../components/common/loading'

class Library extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showEvents: true
    }
  }

  componentWillMount() {
    if (this.state.showEvents) this.props.fetchEventList()
    this.props.fetchRiderList()
  }

  componentWillReceiveProps(nextProps) {
    const { event, rider } = nextProps

    if (event.createdEventId !== this.props.event.createdEventId) {
      this.props.history.replace({pathname: `/event/${event.createdEventId}`})
    }

    if (rider.createdRiderId !== this.props.rider.createdRiderId) {
      this.props.history.replace({pathname: `/rider/${rider.createdRiderId}`})
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { library } = nextProps

    if (library !== this.props.library) return true
    if (nextState !== this.state) return true
    return false
  }

  mapItems(items, type) {
    if (items === undefined || items.length === 0) return (
      <div>
        {`Seems like we did not find any ${type}s. `}
        <a>Start by creating one.</a>
      </div>
    )

    return items.map((item, index) => (
      <li key={index}>
        <Link to={`/${type}/${item.id}`}>
          <span className="title">
            {item.title}
          </span>

          <span className="description">
            <small>Artist: {item.artist}</small>
            <small>Owner: {item.owner}</small>
          </span>
        </Link>
      </li>
    ))
  }

  renderEvents(event) {
    const eventHasLoaded = Object.keys(event).length === 0 || event.isFetching === true

    return (
      <section>
        <h2>Events</h2>

        {
          eventHasLoaded
          ? <Loading className="library" />
          : event.items && event.items.length > 0
            ? <ul className="library-list">
                {this.mapItems(event.items, 'event')}

                <li className="add" onClick={() => this.props.setModal('EventCreateModal')}>
                  <h1>+</h1>
                </li>
              </ul>
            : <ul className="library-list">
                <li className="add" onClick={() => this.props.setModal('EventCreateModal')}>
                  <h1>+</h1>
                </li>
              </ul>
        }
      </section>
    )
  }

  renderRiders(rider) {
    const riderHasLoaded = Object.keys(rider).length === 0 || rider.isFetching === true

    return (
      <section>
        <h2>Riders</h2>

        {
          riderHasLoaded
          ? <Loading className="library" />
          : rider.items && rider.items.length > 0
            ? <ul className="library-list library-list--riders">
                {this.mapItems(rider.items, 'rider')}

                <li className="add" onClick={() => this.props.setModal('RiderCreateModal')}>
                  <h1>+</h1>
                </li>
              </ul>
            : <ul className="library-list library-list--riders">
                <li className="add" onClick={() => this.props.setModal('RiderCreateModal')}>
                  <h1>+</h1>
                </li>
              </ul>
        }
      </section>
    )
  }

  render() {
    const { library } = this.props
    const { event, rider } = library
    const { showEvents } = this.state

    return (
      <div className="library">
        {
          showEvents
          ? this.renderEvents(event)
          : null
        }

        {this.renderRiders(rider)}
      </div>
    )
  }
}

Library.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  userSession: PropTypes.object,
  library: PropTypes.object,
  fetchEventList: PropTypes.func,
  fetchRiderList: PropTypes.func,
  event: PropTypes.object,
  rider: PropTypes.object,
  setModal: PropTypes.func
}

Library.defaultProps = {
  match: {},
  location: {},
  history: {},
  userSession: {},
  library: {},
  fetchEventList: function() {},
  fetchRiderList: function() {},
  event: {},
  rider: {},
  setModal: function() {}
}

export const mapStateToProps = (state) => {
  return {
    library: state.library,
    event: state.event,
    rider: state.rider
  }
}

export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    fetchEventList,
    fetchRiderList,
    setModal
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Library)



// WEBPACK FOOTER //
// ./src/containers/library.js